// src/pages/MasterManagement.jsx
import "bootstrap-icons/font/bootstrap-icons.css";
import { Link } from "react-router-dom";
import "../css/MasterManagement.css";
import useIdleLogout from "../hooks/useIdleLogout";

export default function MasterManagement() {
  useIdleLogout();

  return (
    <div className="management-page">
      {/* Main content */}
      <div className="management-content p-4">
        {/* Strict 2x2 Grid */}
        <div className="master-grid">
          {/* Role Management */}
          <div className="quick-card">
            <i className="bi bi-people-fill icon-lg"></i>
            <h5>Role Management</h5>
            <Link
              to="/master-management/role-management"
              className="btn btn-sm btn-outline-primary mt-2"
            >
              Manage Roles
            </Link>
          </div>

          {/* Notifications */}
          <div className="quick-card">
            <i className="bi bi-bell-fill icon-lg"></i>
            <h5>Notifications</h5>
            <Link
              to="/master-management/notifications"
              className="btn btn-sm btn-outline-primary mt-2"
            >
              Configure
            </Link>
          </div>

          {/* Points Management */}
          <div className="quick-card">
            <i className="bi bi-award icon-lg"></i>
            <h5>Points Management</h5>
            <Link
              to="/master-management/points-management"
              className="btn btn-sm btn-outline-primary mt-2"
            >
              Manage Points
            </Link>
          </div>

          {/* Tax Management */}
          <div className="quick-card">
            <i className="bi bi-receipt icon-lg"></i>
            <h5>Tax Management</h5>
            <Link
              to="/master-management/tax-management"
              className="btn btn-sm btn-outline-primary mt-2"
            >
              Manage Tax
            </Link>
          </div>

          {/* Platform Fee Management */}
          <div className="quick-card">
            <i className="bi bi-percent icon-lg"></i>
            <h5>Platform Fee Management</h5>
            <Link
              to="/master-management/platform-fee-management"
              className="btn btn-sm btn-outline-primary mt-2"
            >
              Manage Fee
            </Link>
          </div>

          {/* NEW: Offers and Rewards */}
          <div className="quick-card">
            <i className="bi bi-gift-fill icon-lg"></i>
            <h5>Offers Management</h5>
            <Link
              to="/master-management/offers-and-rewards"
              className="btn btn-sm btn-outline-primary mt-2"
            >
              Manage Offers
            </Link>
          </div>

          {/* Logo / Image Management */}
          <div className="quick-card">
            <i className="bi bi-image-fill icon-lg"></i>
            <h5>Logo and Image Management</h5>
            <Link
              to="/master-management/logo-management"
              className="btn btn-sm btn-outline-primary mt-2"
            >
              Manage Logos/Images
            </Link>
          </div>

          {/* (Optional cards kept commented) */}
          {/*
          <div className="quick-card">
            <i className="bi bi-grid-3x3-gap-fill icon-lg"></i>
            <h5>Service Categories</h5>
            <p>2 new categories added</p>
            <div className="stats-bar bg-warning"></div>
            <Link
              to="/master-management/service-categories"
              className="btn btn-sm btn-outline-primary mt-2"
            >
              Edit Services
            </Link>
          </div>

          <div className="quick-card">
            <i className="bi bi-palette-fill icon-lg"></i>
            <h5>App Branding</h5>
            <p>Theme updated 2 days ago</p>
            <div className="stats-bar bg-secondary"></div>
            <Link
              to="/master-management/app-branding"
              className="btn btn-sm btn-outline-primary mt-2"
            >
              Update Branding
            </Link>
          </div>
          */}
        </div>
      </div>

      {/* Sticky-to-bottom footer */}
      <footer className="management-footer">
        <small>
          © {new Date().getFullYear()} <strong>སྟབས་བདེ། </strong> Admin • All
          rights reserved
        </small>
      </footer>
    </div>
  );
}